var map = {
	"./biglow-woodcraft.jpg": 23,
	"./biglow-woodcraft2.jpg": 43,
	"./biglow-woodcraft3.jpg": 44,
	"./biglow-woodcraft4.jpg": 45,
	"./biglow-woodcraft5.jpg": 46,
	"./biglow-woodcraft6.jpg": 47,
	"./biglow-woodcraft7.jpg": 48,
	"./biglow-woodcraft8.jpg": 49
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42;